// A row as a Dynamic App reads it: every cell the viewer may see, each lookup with the cells its
// targets' chains end at. Rows are always read whole, so one selection serves every read.
const APP_TABLE_ROW_FIELDS = `fragment AppTableRowFields on AppTableRow {
  id
  createdAt
  updatedAt
  createdBy
  updatedBy
  parentRowId
  cells { id at value display targets { rowId cells { id at value display } } }
}`

/**
 * The GraphQL documents an App's row reads run, by operation name. The frame names one and sends
 * its variables; the host runs its own copy, so a frame never sends a document.
 */
export const APP_GRAPHQL_DOCUMENTS = {
  AppTableRows: `query AppTableRows($input: AppTableRowsInput!) {
  appTableRows(input: $input) { rows { ...AppTableRowFields } select { as field } hasNext totalCount }
}
${APP_TABLE_ROW_FIELDS}`,
  AppTableRowCount: `query AppTableRowCount($input: AppTableRowsInput!) {
  appTableRows(input: $input) { totalCount }
}`,
  AppTableDistinct: `query AppTableDistinct($input: AppTableDistinctInput!) {
  appTableDistinct(input: $input) { values { value display rowCount } truncated }
}`,
} as const

export type AppGraphqlOperation = keyof typeof APP_GRAPHQL_DOCUMENTS
